import { Control, useController, FieldValues } from 'react-hook-form';
import { SliderQuestionnaire } from '@/components/design-system/Questionnaires/SliderQuestionnaire';

interface Props {
  control: Control<FieldValues>;
  name: string;
  subtitle?: string;
  required?: boolean;
  ranges?: number[];
  disabled?: boolean;
  startValueRepresent?: string;
  endValueRepresent?: string;
}

const SliderWrapper: React.FC<Props> = ({
  control,
  name,
  subtitle,
  ranges = [0, 10],
  disabled = false,
  startValueRepresent,
  endValueRepresent,
}) => {
  const min = ranges[0] ?? 0;
  const max = ranges[1] ?? 10;

  const {
    field: { onChange, value, ...field },
    fieldState: { error },
  } = useController({
    name,
    control,
    defaultValue: String(Math.floor((max - min) / 2 + min)),
  });

  // Convert string to number for the slider
  const numericValue = Number(value) || min;

  const handleChange = (newValue: number[]) => {
    // Convert number to string before setting form value
    onChange(newValue[0].toString());
  };

  return (
    <div className={`w-full ${subtitle ? 'mt-4' : 'mt-10'}`}>
      {subtitle && <p className="text-sm text-gray-500 mb-10">{subtitle}</p>}
      <SliderQuestionnaire
        id={`slider-${name}`}
        min={min}
        max={max}
        value={[numericValue]}
        onValueChange={handleChange}
        disabled={disabled}
        minRangeText={startValueRepresent}
        maxRangeText={endValueRepresent}
        colors={(numericValue > 10) ? ['#A0A1AD', '#DA1C2C'] : []}
        {...field}
      />
      {error && <p className="text-red-500 mt-2">{error.message}</p>}
    </div>
  );
};

export default SliderWrapper;
